// extracted by mini-css-extract-plugin
module.exports = {"heading":"_7a3fb80146--heading--iPQ2V","content":"_7a3fb80146--content--wjeel"};